import { addLoader, apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const appAdminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAppAdmin: builder.query({
      query: (appId) => ({
        url: `/apps_admin/${appId}`
        }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: arg } ],
      onQueryStarted: addLoader(),
    }),
    updateAppAdmin: builder.mutation({
      query: (app) => ({
        url: `/apps_admin/${app.slug}`,
        method: 'PUT',
        body: app
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'AppsAdmin', id: arg.slug }],
    }),
    deleteAppAdmin: builder.mutation({
      query: (appId) => ({
        url: `/apps_admin/${appId}`,
        method: 'DELETE',
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [{ type: 'AppsAdmin', id: arg }],
    }),
    getAppAdminDataByDay: builder.query({
      query: (appId) => ({
        url: `/apps_admin/${appId}/data_by_day`
      }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: `admin_data_by_day:${arg}` } ],
    }),
    getAppAdminLocationStatus: builder.query({
      query: (app) => ({
        url: `/apps_admin/${app}/location_status`
      }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: `location_status:${arg}` } ],
    }),
    getAppAdminSdkVersionPerOs: builder.query({
      query: (app) => ({
        url: `/apps_admin/${app}/sdk_version_per_os`
      }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: `sdk_version_per_os:${arg}` } ],
    }),
    getAppAdminOsVersionPerOs: builder.query({
      query: (app) => ({
        url: `/apps_admin/${app}/os_version_per_os`
      }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: `os_version_per_os:${arg}` } ],
    }),
    getAppAdminSdkVersionPerDay: builder.query({
      query: (app) => ({
        url: `/apps_admin/${app}/sdk_version_by_day`
      }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: `sdk_version_by_day:${arg}` } ],
    }),
    getAppAdminOsVersionPerDay: builder.query({
      query: (app) => ({
        url: `/apps_admin/${app}/os_version_by_day`
      }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: `os_version_by_day:${arg}` } ],
    }),
    getAppAdminLocationStatusPerOsVersion: builder.query({
      query: (app) => ({
        url: `/apps_admin/${app}/location_status_per_os_version`
      }),
      providesTags: (result = [], error, arg) => [{ type: 'AppsAdmin', id: `location_status_per_os_version:${arg}` } ],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetAppAdminQuery,
  useGetAppAdminDataByDayQuery,
  useGetAppAdminLocationStatusQuery,
  useGetAppAdminSdkVersionPerOsQuery,
  useGetAppAdminOsVersionPerOsQuery,
  useGetAppAdminSdkVersionPerDayQuery,
  useGetAppAdminOsVersionPerDayQuery,
  useGetAppAdminLocationStatusPerOsVersionQuery,
  useUpdateAppAdminMutation,
  useDeleteAppAdminMutation,
} = appAdminApiSlice
